
export const getToken = () => {
  const existingTokens = JSON.parse(localStorage.getItem("auth"));

  if (existingTokens) {
    if (existingTokens.expires_in > Date.now() / 1000) {
      return existingTokens.access_token;
    }
  }

  return "";
};
